<script>
import Vue from "vue";
import FormControls from "../FormControls/index.js";
Vue.use(FormControls);
import render from "./utils/render.js";
import { trigger } from "./components/generator/config.js";
import * as Formx from "@/api/form/data";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
import "katex/dist/katex.min.css";
const Base64 = require("js-base64").Base64;
import { listStuMajor } from "@/api/stu/stu_major";
import {
  FormxShowForminfo,
  FormxShowList,
  FormxShowGet,
} from "@/api/form/data";
import { listData } from "@/api/core/data/dict/data";
import { execModel } from "@/api/core/data/datasource/model";
import { listUser } from "@/api/core/system/user";
import { listStuStudent } from "@/api/stu/stu_student";
import { streamChats } from "@/api/bpm/ai";
/**
 * 校验组织机构组件是否为空
 */
const setFcOrgSelectRule = (conf, ctx) => {
  return {
    validator: (rule, value, callback) => {
      var val = ctx.formModel[rule.field];
      if (Object.keys(val || {}).length === 0) {
        callback();
        return;
      }

      var count = 0;
      conf.tabList.forEach((key) => {
        val && Array.isArray(val[key]) && (count += val[key].length);
      });
      callback(count ? undefined : new Error(`${conf.title}不能为空`));
    },
    trigger: trigger[conf.tag],
    type: "object",
    required: true,
  };
};
/**
 * 收集表单必填项并组装成ElementUI表单校验得rules选项
 * 表格除外 表格自带校验
 */
function buildRules(conf, ctx) {
  if (conf.vModel === undefined || !trigger[conf.tag]) return;
  const rules = [];
  if (conf.required) {
    const type = Array.isArray(conf.defaultValue) ? "array" : undefined;
    let message = Array.isArray(conf.defaultValue)
      ? `请至少选择一个`
      : conf.placeholder;
    if (message === undefined) message = `${conf.label}不能为空`;
    conf.tag === "fc-org-select" || conf.tag === "post-select"
      ? rules.push(setFcOrgSelectRule(conf, ctx))
      : rules.push({
          required: true,
          type,
          message,
          trigger: trigger[conf.tag],
        });
  }
  // 自定义正则匹配
  if (conf.regList && Array.isArray(conf.regList)) {
    conf.regList.forEach((item) => {
      if (item.pattern) {
        rules.push({
          pattern: eval(item.pattern),
          message: item.message,
          trigger: trigger[conf.tag],
        });
      }
    });
  }
  ctx.ruleList[conf.vModel] = rules;
}

var setData = (ctx, val, prop, init = false) => {
  if (!prop) return;
  ctx.$set(ctx.formModel, prop, val);
  if (
    ctx.$route.query &&
    ctx.$route.query.flowId == 10019 &&
    ctx.$route.query.title &&
    ctx.$route.query.title.indexOf("归档管理") &&
    prop == "student"
  ) {
    ctx.getStudent(prop, val);
  }
  //   if(ctx.$route.query &&[1042,1045,1041,1044,1043,1046].includes( ctx.$route.query.flowId*1)>-1){
  //     ctx.getScore(conf, val);
  // }
};

let _isMounted = false; // 收集默认值 渲染完成之后防止重复收集默认值
let _isfieldchanged = {};
const buildData = (ctx, value, prop) => setData(ctx, value, prop, true);

const layouts = {
  colFormItem: function (conf, h, ctx, isList = false) {
    buildRules(conf, ctx);
    !_isMounted && buildData(ctx, conf.defaultValue, conf.vModel);
    let labelWidth = "";
    if (conf.labelWidth) labelWidth = `${conf.labelWidth}px`;
    if (isList) labelWidth = "0px";
    const required =
      (!trigger[conf.tag] && conf.required) ||
      conf.tag === "fc-org-select" ||
      conf.tag === "post-select" ||
      conf.tag === "fc-form-input-table";
    const handleInput = (val) => {
      if (_isfieldchanged[conf.vModel] != val) {
        _isfieldchanged[conf.vModel] = val;
        ctx.getMajor(conf, val);
        ctx.getLabel(conf, val);
        ctx.getDeptDirector(conf, val);
      }

      //todo: 延迟设置为空 可二次触发 后续在优化

      setData(ctx, val, conf.vModel);
      if (conf.type === "select") {
        ctx.formFieldLinkAction(val, conf);
        if (conf.vModel.indexOf("v_") > -1) {
          ctx.caclLECD(val, conf);
        }
      }
      if (conf.type === "radio" || conf.type === "checkbox") {
        ctx.formDataChange(conf.formId, conf.vModel);
        ctx.getScore(conf, val);
      }
      if (conf.type === "radio") {
        ctx.$emit("radioChange", { vModel: conf.vModel, val: val });
      }
      if (["input", "textarea"].includes(conf.tagIcon)) {
        ctx.$emit("inputChange", conf.vModel, val);
      }
      if (
        [
          "fc-amount",
          "el-input-number",
          "el-slider",
          "fc-calculate",
          "fc-date-duration",
          "fc-time-duration",
          "fc-org-select",
          "fc-form-input-table",
          "post-select",
          "el-select",
          "el-radio-group",
        ].includes(conf.tag)
      ) {
        ctx.$emit("conditionChange");
        if (
          val !== undefined &&
          (val.constructor !== Array ||
            val.length == 0 ||
            (val.length > 0 && val.filter((item) => item).length > 0))
        ) {
          ctx.formDataChange(conf.formId, conf.vModel);
        }
      }
      if (
        conf.tag === "fc-org-select" ||
        conf.tag === "post-select" ||
        conf.tag === "fc-form-input-table"
      ) {
        /**
         * 组织机构组件数据复杂
         * async-validator不一定能准确捕获到数据变化
         * 所以在这里手动校验一次
         */
        ctx.$refs[ctx.confGlobal.formRef].validateField(conf.vModel, () => {});
      }
    };
    const handleAi = (val) => {
      console.log(val);
      ctx.getAIDetail(val);
    };
    const handlePreview = (conf, file, fileList) => {
      //viewjs浏览
      ctx.imgViewerId = "viewer_" + new Date().getTime();
      ctx.imgViewerFileList = fileList;
      ctx.imgViewer && ctx.imgViewer.destroy();
      ctx.$nextTick(() => {
        ctx.imgViewer = new Viewer(document.getElementById(ctx.imgViewerId));
        ctx.imgViewer.view(fileList.findIndex((item) => item.url === file.url));
      });
    };
    const handleBlur = (val) => {
      // ctx.$emit("formDataChange", val);
      if (conf.tag !== "el-select") {
        ctx.formDataChange(conf.formId, conf.vModel);
      }
    };

    let item = !conf.show ? (
      <el-col span={conf.span}>
        <el-form-item
          label-width={labelWidth}
          label={isList || conf.hideLabel ? "" : conf.label}
          prop={conf.vModel}
        >
          <template slot="label">
            <span>{isList || conf.hideLabel ? "" : conf.label}</span>
            {conf.isOpenAi && (
              <el-tag
                size="mini"
                type="primary"
                style="margin-left: 8px; cursor: pointer;"
                onClick={() => handleAi(conf)}
              >
                AI
              </el-tag>
            )}
          </template>
          <render
            formData={ctx.formModel}
            conf={conf}
            value={ctx.formModel[conf.vModel]}
            ref={conf.rowType === "table" ? conf.vModel : undefined}
            onInput={handleInput}
            onPreview={handlePreview}
            onBlur={handleBlur}
          />
          {/* AI回复显示区域 */}
          {conf.showAiResponse && (
            <div
              class="ai-response-container"
              style="margin-top: 10px; padding: 10px; border: 1px solid #e4e7ed; border-radius: 4px; background-color: #f5f7fa;"
            >
              <div
                class="ai-response-header"
                style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;"
              >
                <span style="font-size: 12px; color: #606266;">
                  <i class="el-icon-cpu"></i> AI助手回复
                </span>
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-close"
                  onClick={() => {
                    ctx.$set(conf, "showAiResponse", false);
                    ctx.$set(conf, "aiResponse", "");
                  }}
                />
              </div>
              {conf.aiLoading && (
                <div
                  class="ai-loading"
                  style="text-align: center; padding: 10px; color: #409EFF;"
                >
                  <i class="el-icon-loading"></i> AI正在思考中...
                </div>
              )}
              {conf.aiResponse && (
                <div
                  class="ai-response-content"
                  style="max-height: 300px; overflow-y: auto; font-size: 14px; line-height: 1.5;"
                >
                  <markdown-it-vue
                    content={conf.aiResponse}
                    options={ctx.markdownOptions}
                  />
                </div>
              )}
            </div>
          )}
        </el-form-item>
      </el-col>
    ) : null;
    if (isList) {
      var tableTitle = !conf.show ? (
        <el-col
          span={24}
          style="font-size: 14px;padding:6px 0px;margin-bottom: 4px;border-bottom: 1px solid #e5e5e5;"
        >
          {conf.label}
        </el-col>
      ) : null;
      return [tableTitle, item];
    }
    return item;
  },

  rowFormItem: function (conf, h, ctx) {
    if (conf.rowType === "table") {
      ctx.tableRefs[conf.vModel] = conf;
      const param = {
        ...conf,
        config: conf,
        formSize: ctx.confGlobal.size,
        labelWidth: `${conf.labelWidth || ctx.confGlobal.labelWidth}px`,
      };
      return this.colFormItem(param, h, ctx, conf.type === "list");
    }
    buildRules(conf, ctx);
    const props = {
      type: conf.type === "default" ? undefined : conf.type,
      justify: conf.type === "default" ? undefined : conf.justify,
      align: conf.type === "default" ? undefined : conf.align,
      gutter: typeof conf.gutter === "number" ? conf.gutter : undefined,
    };
    let row = !conf.show ? (
      <el-col span={conf.span || 24}>
        <el-row {...{ props: props }}>
          {Array.isArray(conf.children) &&
            conf.children.map((el) => layouts[el.layout](el, h, ctx))}
        </el-row>
      </el-col>
    ) : null;
    let divider;
    if (conf.showDivider) {
      let explain;
      if (conf.cmpType === "custom" && conf.explain) {
        explain = (
          <el-tooltip effect="dark" content="组件说明" placement="top">
            <i
              class="el-icon-info"
              onClick={ctx.showExplain.bind(this, conf.explain, conf.label)}
              style="margin-right: 8px; color: #E6A23C;cursor: pointer;"
            ></i>
          </el-tooltip>
        );
      }
      divider = !conf.show ? (
        <el-col span={24}>
          <el-divider content-position="left">
            {explain} {conf.label}
          </el-divider>
        </el-col>
      ) : null;
      return [divider, row];
    }
    return row;
  },
};

export default {
  components: {
    MarkdownItVue,
  },
  props: {
    conf: Object,
    confData: Object,
    formBtns: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      displayText: "",
      isinit: false,
      LECDdata: null,
      markdownOptions: {
        markdownIt: {
          linkify: true,
          breaks: true,
          html: true,
        },
        markdownItPlugins: {
          "markdown-it-katex": {
            throwOnError: false,
            errorColor: "#cc0000",
          },
        },
      },
      imgViewerFileList: [],
      imgViewer: null,
      imgViewerId: "viewer_" + new Date().getTime(),
      tableRefs: {},
      drawerTitle: "",
      drawerText: "",
      drawerVisible: false,
      containerWidth: 100,
      confGlobal: this.$route.params.formData || null,
      formModel: {},
      ruleList: {},
      calculationTypes: [
        {
          value: "=",
          label: "等于",
        },
        {
          value: "≠",
          label: "不等于",
        },
        {
          value: "⊆",
          label: "包含",
        },
        {
          value: "⊄",
          label: "不包含",
        },
        {
          value: ">=",
          label: "大于等于",
        },
        {
          value: "<=",
          label: "小于等于",
        },
        {
          value: ">",
          label: "大于",
        },
        {
          value: "<",
          label: "小于",
        },
      ],
      actionTypes: [
        { value: "1", label: "显示表单字段" },
        { value: "2", label: "隐藏表单字段" },
        { value: "3", label: "允许编辑表单字段" },
        { value: "4", label: "禁止编辑表单字段" },
        { value: "5", label: "设置表单字段值" },
      ],
      selectVal: {
        label: "下拉选择",
        tag: "el-select",
        tagIcon: "select",
        showpos: [],
        type: "select",
        placeholder: "请选择",
        style: { width: "100%" },
        defaultValue: undefined,
        span: 24,
        labelWidth: null,
        clearable: true,
        disabled: false,
        required: false,
        filterable: false,
        multiple: false,
        options: [
          {
            label: "选项一",
            value: "选项一",
          },
          {
            label: "选项二",
            value: "选项二",
          },
        ],
        regList: [],
        changeTag: true,
        proCondition: true,
        //关联表单引擎
        formsvr: {
          id: undefined,
          optionLabel: undefined,
          optionValue: "id",
          staticfilter: "", //静态条件
        },
        show: false,
        isApphide: false,
        linkfields: "", //联动字段 用于动态设置下拉数据
        optionsdataconfig: {
          type: "formrow", //表单行数据
          form: "", //表单 表单id:数据id  234234:1
          labelfield: "", //标签取值配置subform39415.[v_E]+分+-+subform39415.[input29579]
          valuefield: "", //数值取值配置subform39415.[v_E]
        },
      },
    };
  },
  watch: {
    conf: {
      handler(newVal) {
        this.confGlobal = newVal;
        this.$nextTick(() => {
          this.getFieldsInit();
        });
        this.getStudentScore();
      },
      immediate: true,
      deep: false,
    },
    confData: {
      handler(val) {},
      immediate: true,
      deep: false,
    },
  },
  mounted() {
    if (!this.confGlobal) {
      this.getConfigByAjax();
    }
    //  else {
    //   this.initDefaultData(this.confGlobal);
    // }

    _isMounted = true;
    //加载表单关联数据到下拉框
    //  this.initResourceData(this.confGlobal);

    this.$emit("formMounted");
    //加载风险标准
    if (
      this.LECDdata == null &&
      (process.env.NODE_ENV == "development" ||
        process.env.VUE_APP_TITLE.indexOf("安全生产") > -1)
    ) {
      FormxShowGet("35507080202245", 1)
        .then((rs) => {
          this.LECDdata = rs.data.row;
        })
        .catch(() => {});
    }
  },
  beforeDestroy() {
    //重要
    _isMounted = false;
  },
  methods: {
    getAIDetail(row) {
      if (!this.formModel[row.vModel]) {
        this.$message({ type: "warning", message: "请先填充数据！" });
        return;
      }
      let params = {
        prompt: row.aiTips,
        usercontent: this.formModel[row.vModel],
        userfile: "",
      };
      if (row.tag === "el-upload") {
        params.userfile =
         window.location.origin +
          row.defaultValue[0].url +
          "?filename=" +
          row.defaultValue[0].filename;
        params.usercontent = "";//清空用户输入
      }
      // 初始化AI回复到字段配置上
      this.$set(row, "aiResponse", ""); //清空AI回复
      this.$set(row, "aiLoading", true); //显示AI加载中
      this.$set(row, "showAiResponse", true); //显示AI回复
      const controller = streamChats({
        api: this.confGlobal.aiApiUrl,
        params: {
          flowid: "10045" || this.$route.query.flowId, //流程id
          data: JSON.stringify(params), //表单数据
        },
        complete: (res) => {
          console.log(res, "该请求结束事件");
          this.$set(row, "aiLoading", false);
        },
        chunked: (data) => {
          console.log("进入这里了吗");
          // 分段收到的数据
          if (data.response) {
            row.aiResponse += data.response;
            console.log(data, row.aiResponse, "分段收到数据");
          }
          //是否结束
          if (data.done) {
            this.$set(row, "aiLoading", false);
          }
        },
        fail: (err) => {
          console.log("fail", err);
          this.$set(row, "aiLoading", false);
          this.$set(row, "aiResponse", err || "AI请求失败");
        },
      });
      console.log(row, "getAIDetail");
    },
    //获取学生成绩
    getStudentScore() {
      let flowId = this.$route.query.flowId;
      let index = -1;
      let list = [];
      let userNamess = localStorage.getItem("userNamess");
      // ? JSON.parse(localStorage.getItem("userNamess"))
      // : "";
      if (flowId == 10022) {
        index = this.confGlobal.fields.findIndex(
          (item) => item.vModel == "number24"
        );
        if (index > -1) {
          list = this.getFormsrvData("89137702533125", { stu_no: userNamess });
          list.then((res) => {
            if (res.length == 1) this.formModel["number24"] = res[0].input49699;
          });
        }
      }

      if (flowId == 10021) {
        index = this.confGlobal.fields.findIndex(
          (item) => item.vModel == "input8"
        );
        if (index > -1) {
          list = this.getFormsrvData("89135069896709", { stu_no: userNamess });
          list.then((res) => {
            if (res.length == 1) this.formModel["input8"] = res[0].input38872;
          });
        }
      }
    },
    //获取部门责任人，安全生产、隐患汇报、证件管理
    getDeptDirector(conf, val) {
      let flowId = this.$route.query.flowId;
      if (
        flowId &&
        conf.tag === "fc-org-select" &&
        ((flowId == "10006" && conf.vModel == "zrdept") ||
          (flowId == "97" && conf.vModel == "zgbm"))
      ) {
        let user_text = flowId == "97" ? "zgfzr" : "zruser";
        let form_id = flowId == "97" ? "37404248381445" : "70708015171589";
        let form_user_text = flowId == "97" ? "zgr" : "fzr";
        let index = this.confGlobal.fields.findIndex(
          (o) => o.vModel == user_text
        );
        if (index < 0) return;
        if (val && val.dep && val.dep.length) {
          let list = this.getFormsrvData(form_id, {
            bmid: val.dep[0].deptId,
          });
          list.then((res) => {
            if (res.length == 0) return;
            try {
              let arr = JSON.parse(res[0][form_user_text]);
              let userIds = arr.length
                ? arr.map((o) => o.userId).join(",")
                : "";
              this.$set(this.confGlobal.fields[index], "userIds", userIds);
              this.confGlobal.fields = JSON.parse(
                JSON.stringify(this.confGlobal.fields)
              );
            } catch (e) {
              //TODO handle the exception
            }
          });
        } else {
          this.$set(this.confGlobal.fields[index], "userIds", "");
          this.formModel[this.confGlobal.fields[index].vModel] = "";
          this.confGlobal.fields = JSON.parse(
            JSON.stringify(this.confGlobal.fields)
          );
        }
      }
    },
    //获取得分
    getScore(conf, val) {
      if (conf.type === "radio" && conf.label.indexOf("意见") > -1) {
        let index = this.confGlobal.fields.findIndex(
          (o) => o.label.indexOf("得分") > -1
        );
        let field = index > -1 ? this.confGlobal.fields[index] : {};
        let radios = this.confGlobal.fields
          .filter((o) => o.type === "radio" && o.label.indexOf("意见") > -1)
          .map((o) => o.vModel);
        if (index > 0 && field.type === "number") {
          if (val === "同意") {
            this.formModel[field.vModel] = field.max;
          } else {
            this.formModel[field.vModel] = field.min;
          }
        }
        if (radios.length > 1) {
          radios.forEach((item) => {
            if (this.formModel[item] === "不同意") {
              this.formModel[field.vModel] = field.min;
            }
          });
        }
      }
    },
    getKeyTranslate(conf, val) {
      let tags = [
        "fc-data-source",
        "fc-dict",
        "el-checkbox-group",
        "el-radio-group",
        "el-select",
      ];
      if (tags.indexOf(conf.tag) == -1) return;

      let index = this.confGlobal.fields.findIndex(
        (o) => o.vModel === conf.vModel + "_text"
      );
      if (index == -1) return;
      if (!val) this.formModel[conf.vModel + "_text"] = "";
      switch (conf.tag) {
        case "el-checkbox-group":
          let array = conf.options
            .filter((o) => {
              if (val.indexOf(o.value)) {
                return o;
              }
            })
            .map((o) => o.label);
          this.formModel[conf.vModel + "_text"] = array.join("、");
          break;
        case "el-radio-group":
          let i = conf.options.findIndex((o) => o.value == val);

          this.formModel[conf.vModel + "_text"] =
            i > -1 ? conf.options[i].label : "";
          break;
        case "el-select":
          let arr = conf.options.filter((o) => {
            if (conf.multiple) {
              return val.indexOf(o.value) != -1;
            } else {
              return o.value == val;
            }
          });
          if (arr.length) {
            this.formModel[conf.vModel + "_text"] = conf.multiple
              ? arr.map((o) => o.label).join("、")
              : arr[0].label;
          }
          break;

        case "fc-data-source":
          execModel(
            conf.dsConf_dstid,
            JSON.stringify({ __max_count__: 9999 })
          ).then((res) => {
            let dsConf_dst_label = conf.dsConf_dst_label.split(":")[0];
            let dsConf_dst_value = conf.dsConf_dst_value.split(":")[0];
            let array = res.data.filter((o) => {
              if (conf.multiple) {
                return val.indexOf(o[dsConf_dst_value]) != -1;
              } else {
                return o[dsConf_dst_value] == val;
              }
            });
            if (array.length) {
              this.formModel[conf.vModel + "_text"] = conf.multiple
                ? array.map((o) => o[dsConf_dst_label]).join("、")
                : array[0][dsConf_dst_label];
            }
          });

          break;
        case "fc-dict":
          listData({
            pageNum: 1,
            type: conf.dictType,
            pageSize: 9999,
          }).then((response) => {
            let array = response.data.list.filter((o) => {
              if (conf.multiple) {
                return val.indexOf(o.value) != -1;
              } else {
                return o.value == val;
              }
            });
            if (array.length > 0) {
              this.formModel[conf.vModel + "_text"] = conf.multiple
                ? array.map((o) => o.label).join("、")
                : array[0].label;
            }
          });

          break;
      }
    },
    //翻译显示
    getLabel(conf, val) {
      let flowId = this.$route.query.flowId;

      // 证件
      if (
        flowId == "10006" &&
        (conf.vModel === "device_type" || conf.vModel === "person_type")
      ) {
        let index = conf.options.findIndex(
          (o) => o.label === val || o.value == val
        );
        let obj = index > -1 ? conf.options[index].originData : {};
        if (!val) this.formModel["name"] = "";
        this.formModel["name"] = obj.sbmc;
      }
      if (conf.rowType === "table") {
        let value = val.length ? val[0] : {};
        conf.children.forEach((item) => {
          this.getKeyTranslate(item, value[item.vModel]);
        });
      } else {
        this.getKeyTranslate(conf, val);
      }
    },
    getMajor(cof, val) {
      if (cof.label === "所属院系") {
        let field_i = this.confGlobal.fields.findIndex(
          (f) => f.label === "所属专业"
        );
        let field = this.confGlobal.fields[field_i];
        let list = [];
        if (field_i < 0) return;
        //如果已选择院系，则将该表单转换成下拉选择，并且赋值
        if (val) {
          listStuMajor({
            pageNum: 1,
            pageSize: 9999,
            qc_resultData: true,
            dept_no: val,
          }).then((res) => {
            list = res.data.list.map((item) => {
              return {
                label: item.name,
                value: item.no,
              };
            });

            field["type"] = "select";
            field["tag"] = "el-select";
            field["options"] = list;
            this.$set(
              this.confGlobal.fields,
              field_i,
              JSON.parse(JSON.stringify(field))
            );
          });
        } else {
          field["type"] = "data-source";
          field["tag"] = "fc-data-source";
          if (field["options"]) {
            delete field["options"];
          }
          this.$set(
            this.confGlobal.fields,
            field_i,
            JSON.parse(JSON.stringify(field))
          );
          this.confGlobal.fields[field_i].defaultValue = "";
          this.formModel[field["vModel"]] = "";
        }
      }
    },
    isBase64(str) {
      // 使用正则表达式匹配Base64编码格式
      const base64RegExp =
        /^(?:[A-Za-z\d+/]*)(?:[A-Za-z\d+/]{2}==|[A-Za-z\d+/]{3}=)?$/;

      // 检查字符串是否匹配Base64编码格式
      return base64RegExp.test(str);
    },
    //获取学生信息
    getStudent(field, val) {
      if (val && val.user && val.user.length && val.user[0].userName) {
        listStuStudent({ no: val.user[0].userName }).then((res) => {
          if (res.data.list && res.data.list.length) {
            const stu1 = res.data.list[0];
            let ext = {};
            try {
              ext = stu1.ext ? JSON.parse(stu1.ext) : {};
            } catch (error) {}
            if (ext.xygdzt == 1 || (ext.gdspzt && ext.gdspzt != 4)) {
              this.$message.error("该学生档案已归档，请勿重复发起！");
              this.$set(this.formModel, field, {});
              this.confGlobal.fields = JSON.parse(
                JSON.stringify(this.confGlobal.fields)
              );
              this.$forceUpdate();
              return;
            }
            for (let i in stu1) {
              if (i === "dept_name") {
                this.$set(this.formModel, "college_name", stu1[i]);
              }
              let index = this.confGlobal.fields.findIndex(
                (o) => o.vModel == i
              );
              if (index > -1 && stu1[i]) {
                this.$set(
                  this.confGlobal.fields[index],
                  "defaultValue",
                  stu1[i]
                );
                this.$set(this.formModel, i, stu1[i]);
                if (i === "gender") {
                  this.$emit("conditionChange");
                }
              }
            }
            this.$set(this.formModel, "studentNo", stu1["no"]);
            this.confGlobal.fields = JSON.parse(
              JSON.stringify(this.confGlobal.fields)
            );
            this.$forceUpdate();
            //强制刷新表单
          }
        });
      }
    },
    getFieldVal(val) {
      if (this.isBase64(val)) {
        val = Base64.decode(val);
      }
      return val;
    },

    parseTime(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    },

    getTimeDifference(startTime, endTime) {
      const startMinutes = this.parseTime(startTime);
      const endMinutes = this.parseTime(endTime);

      return endMinutes - startMinutes;
    },
    async getFormsrvData(mid, inparam) {
      var param = {
        fieldval: {},
        sortinfo: null,
        pageNum: 1,
        pageSize: 999,
      };
      for (let k in inparam) {
        param.fieldval[k] = inparam[k];
      }
      let res = await Formx.FormxShowList(mid, param);
      return res.data.list;
    },
    setFormField(field, inparam, index) {
      if (field.formsvr && field.formsvr.id) {
        var formdatalist = this.getFormsrvData(field.formsvr.id, inparam);
        formdatalist.then((rs) => {
          let toption = [];
          for (let ii in rs) {
            let onerec = rs[ii];
            var optionValue = field.formsvr.optionValue
              ? field.formsvr.optionValue
              : "id";
            toption.push({
              label: onerec[field.formsvr.optionLabel],
              value: onerec[optionValue],
              originData: onerec,
            });
          }
          // field.options = toption;
          field.defaultValue = undefined;
          this.formModel[field.vModel] = undefined;
          this.$set(this.confGlobal.fields[index], "options", toption);
        });
      }
    },

    //表单初始化
    getFieldsInit() {
      return;
      this.isinit = false;
      let formLinks = this.confGlobal.formLinks || [];
      if (formLinks.length > 0) {
        for (let i = 0; i < formLinks.length; i++) {
          let formLink = formLinks[i];
          let condition = false;
          if (formLink.fieldRules.length > 0) {
            let arr = [];
            formLink.fieldRules.forEach((item) => {
              arr.push(this.getCalculate(item, item.condition));
            });

            if (arr.length > 1) {
              if (formLink.calculationType === "&&") {
                condition = !(arr.filter((value) => !value).length > 0);
              } else {
                condition = arr.filter((value) => value).length > 0;
              }
            } else {
              condition = arr[arr.length - 1];
            }
            formLink.actionList.forEach((obj) => {
              obj.field.forEach((field) => {
                let index = this.confGlobal.fields.findIndex(
                  (o) => field == o.formId
                );
                if (index > -1) {
                  this.setConfGlobal(obj, index, condition, field, formLink);
                }
              });
            });
          }
          if (condition) break;
        }
        this.confGlobal.fields.forEach((item, index) => {
          if (item.defaultValue && item.type !== "text") {
            this.formDataChange(item.formId);
          }
        });
      }
      this.isinit = true;

      //遍历获取所有显示的字段
    },
    //返回可显示字段
    getShowfield() {
      if (!this.isinit) {
        return false;
      }
      var showfield = [];
      this.putfield(this.confGlobal.fields, showfield);

      return showfield.join("|");
    },
    putfield(fields, far) {
      for (var j in fields) {
        var onef = fields[j];
        if (
          onef.children != null &&
          (onef.show == null || onef.show == false)
        ) {
          this.putfield(onef.children, far);
        } else {
          if (onef.show == null || onef.show == false) {
            far.push(onef.vModel);
          }
        }
      }
    },
    getCalculate(item, formId) {
      // if(!item.value) item.value=undefined
      let index1 = this.confGlobal.fields.findIndex((o) => o.formId == formId);
      let index2 = this.confGlobal.fields.findIndex(
        (o) => o.formId == item.value
      );
      if (
        (item.valueType == 1 && index1 > -1) ||
        (item.valueType == 2 && index2 > -1 && index1 > -1)
      ) {
        let vModel = this.confGlobal.fields[index1].vModel;
        //因为默认值是空字符串，所以需要判断一下，初始化时this.formModel[vModel]===unfined，清除时等于空字符串
        if (!this.formModel[vModel] && !item.value) {
          item.value = this.formModel[vModel];
        }
        let vModel2 = "";
        if (item.valueType == 2) {
          vModel2 = this.confGlobal.fields[index2].vModel;
        }
        switch (item.calculationType) {
          case "=":
            return item.valueType == 1
              ? item.value == this.formModel[vModel]
              : this.formModel[vModel2] === this.formModel[vModel];

          case "≠":
            return item.valueType == 1
              ? item.value != this.formModel[vModel]
              : this.formModel[vModel2] !== this.formModel[vModel];
          case "⊆":
            return item.valueType == 1
              ? item.value.indexOf(this.formModel[vModel]) != -1
              : this.formModel[vModel2].indexOf(this.formModel[vModel]) != -1;
          case "⊄":
            return item.valueType == 1
              ? item.value.indexOf(this.formModel[vModel]) == -1
              : this.formModel[vModel2].indexOf(this.formModel[vModel]) == -1;
          case ">":
            return item.valueType == 1
              ? this.formModel[vModel] * 1 > item.value * 1
              : this.formModel[vModel2] * 1 > this.formModel[vModel] * 1;
          case "≥":
            return item.valueType == 1
              ? this.formModel[vModel] * 1 >= item.value * 1
              : this.formModel[vModel2] * 1 >= this.formModel[vModel] * 1;
          case "<":
            return item.valueType == 1
              ? this.formModel[vModel] * 1 < item.value * 1
              : this.formModel[vModel2] * 1 < this.formModel[vModel] * 1;
          case "≤":
            return item.valueType == 1
              ? this.formModel[vModel] * 1 <= item.value * 1
              : this.formModel[vModel2] * 1 <= this.formModel[vModel] * 1;
        }
      }
    },
    getAction() {},
    setConfGlobal(obj, index, value, field, formLink) {
      if (obj.action == "1") {
        this.confGlobal.fields[index].show = !value;
      } else if (obj.action == "2") {
        this.confGlobal.fields[index].show = value;
      } else if (obj.action == "3") {
        this.confGlobal.fields[index].disabled = !value;
      } else if (obj.action == "4") {
        this.confGlobal.fields[index].disabled = value;
      } else if (obj.action == "5") {
        if (value) {
          //判断是否关联了表单
          if (field > -1 && formLink.is_formsvr_foreignfieldlist) {
            let fieldRules = {};
            for (let i = 0; i < formLink.fieldRules.length; i++) {
              fieldRules = formLink.fieldRules[i];
              let rules_index = this.confGlobal.fields.findIndex(
                (o) => fieldRules.condition == o.formId
              );
              let options =
                rules_index > -1 && this.confGlobal.fields[rules_index].options
                  ? JSON.parse(
                      JSON.stringify(
                        this.confGlobal.fields[rules_index].options
                      )
                    )
                  : [];
              if (rules_index > -1 && options && options.length > 0) {
                for (
                  let options_index = 0;
                  options_index < options.length;
                  options_index++
                ) {
                  let options_item = options[options_index];
                  if (
                    this.formModel[
                      this.confGlobal.fields[rules_index].vModel
                    ] == options_item.value &&
                    options_item.originData &&
                    Object.keys(options_item.originData).length > 0
                  ) {
                    let originData = options_item.originData;
                    this.$set(
                      this.confGlobal.fields[index],
                      "defaultValue",
                      originData[obj.value]
                    );

                    break;
                  }
                }
              } else {
                this.confGlobal.fields[index].defaultValue = obj.value;
              }
            }
          } else {
            this.confGlobal.fields[index].defaultValue = obj.value;
            this.formModel[this.confGlobal.fields[index].vModel] = obj.value;
          }
        } else {
          if (this.confGlobal.fields[index].defaultValue) {
            this.confGlobal.fields[index].defaultValue = "";
          }
        }
      }
    },
    //风险等级
    caclLECD(val, conf) {
      var ttscore = 1.0;

      for (var field in this.formModel) {
        if (field.indexOf("v_") > -1) {
          var lval = parseFloat(this.formModel[field]);

          if (!isNaN(lval)) {
            ttscore = ttscore * lval;
          }
        }
      }
      if (!isNaN(ttscore)) {
        ttscore = ttscore.toFixed(2);
      } else {
        ttscore = 0;
      }
      this.formModel["d_value"] = ttscore; //记录总分用于统计
      this.formModel[
        "v_d"
      ] = `<div class="__vD" style="background:${this.getlecdcolor(
        ttscore
      )}">${ttscore}</div>`;
    },
    //风险等级颜色
    getlecdcolor(ttscore) {
      var dr1 = parseFloat(this.LECDdata["dr1"]);
      var dr2 = parseFloat(this.LECDdata["dr2"]);
      var dr3 = parseFloat(this.LECDdata["dr3"]);
      if (ttscore >= dr1) {
        return this.LECDdata["color_dr1"];
      } else if (ttscore >= dr2 && ttscore < dr1) {
        return this.LECDdata["color_dr2"];
      } else if (ttscore >= dr3 && ttscore < dr2) {
        return this.LECDdata["color_dr3"];
      } else {
        return this.LECDdata["color_dr4"];
      }
      return "";
    },
    formFieldLinkAction(val, conf) {
      var linkfields = conf.linkfields;
      {
        /* console.log("formFieldLinkAction conf", conf); */
      }
      if (linkfields == null || linkfields == "") {
        return;
      }
      var tar = linkfields.split(":");
      let ff = tar[0];
      let fkey = tar[1];
      this.confGlobal.fields.forEach((item, index) => {
        //判断是不是表单字段
        if (item.layout === "rowFormItem") {
        } else {
          if (item.vModel == ff) {
            let tpa = {};
            tpa[fkey] = val;
            this.setFormField(item, tpa, index);
            item.renderKey = item.formId + new Date().getTime(); // 改变renderKey后可以实现强制更新组件
          }
        }
      });
    },
    formDataChange(formId, vModel) {
      let flowId = this.$route.query.flowId;
      if (this.formModel["start_time"] && this.formModel["end_time"]) {
        this.formModel["duration"] = this.getTimeDifference(
          this.formModel["start_time"],
          this.formModel["end_time"]
        );
      }
      //作业票高处作业规则
      if (
        flowId &&
        flowId == "106" &&
        vModel &&
        (vModel == "input52" || vModel == "input8443")
      ) {
        if (this.formModel["input8443"] > 10) {
          if (15 < this.formModel["input52"] <= 30) {
            this.formModel["select5002"] = "一级高处作业";
          } else if (5 < this.formModel["input52"] <= 15) {
            this.formModel["select5002"] = "二级高处作业";
          }
          return;
        } else {
          if (vModel == "input8443") {
            this.getFieldsInit();
            return;
          }
        }
      }
      let formLinks = this.confGlobal.formLinks || [];
      if (formLinks.length && formId > -1) {
        this.confGlobal.fields.forEach((item) => {
          //判断是不是表单字段
          if (item.layout === "rowFormItem") {
            // ietm.defaultValue = this.formModel[ietm.vModel];
            item.renderKey = item.formId + new Date().getTime(); // 改变renderKey后可以实现强制更新组件
            if (item.children && item.children.length) {
              item.children.forEach((child) => {
                child.defaultValue = this.formModel[child.vModel];
                child.renderKey = child.formId + new Date().getTime(); // 改变renderKey后可以实现强制更新组件
              });
            }
          } else {
            item.defaultValue = this.formModel[item.vModel];
            item.renderKey = item.formId + new Date().getTime(); // 改变renderKey后可以实现强制更新组件
          }
        });

        for (let link_i = 0; link_i < formLinks.length; link_i++) {
          let formLink = formLinks[link_i];
          let condition = false;
          if (formLink.fieldRules.length > 0) {
            if (
              formLink.fieldRules.findIndex(
                (o) =>
                  o.condition == formId ||
                  (o.valueType == 2 && o.value == formId)
              ) > -1
            ) {
              let arr = formLink.fieldRules.map((item) => {
                return this.getCalculate(item, item.condition);
              });

              if (arr.length > 1) {
                if (formLink.calculationType === "&&") {
                  condition = !(arr.filter((value) => !value).length > 0);
                } else {
                  condition = arr.filter((value) => value).length > 0;
                }
              } else {
                condition = arr[arr.length - 1];
              }

              formLink.actionList.forEach((obj) => {
                obj.field.forEach((field) => {
                  let index = this.confGlobal.fields.findIndex(
                    (o) => field == o.formId
                  );
                  if (index > -1) {
                    this.setConfGlobal(obj, index, condition, field, formLink);
                  }
                });
              });
            }
          }
          if (condition) break;
        }
        // this.confGlobal.fields.forEach((item, index) => {
        //    this. formDataChange(item.formId)
        // })
        //强制刷新表单
        this.confGlobal = JSON.parse(JSON.stringify(this.confGlobal));
        // this.initDefaultData(this.confGlobal);
      }
    },
    getDataFields() {
      return this.formModel;
    },
    getData() {
      return new Promise((resolve, reject) => {
        const isTableValid = this.checkTableData();

        this.$refs[this.confGlobal.formRef].validate((valid) => {
          if (!valid) {
            reject("valid error!");
          } else if (!isTableValid) {
            reject("table valid error!");
          } else {
            resolve(this.formModel);
          }
        });
      });
    },
    submitForm() {
      const isTableValid = this.checkTableData();
      this.$refs[this.confGlobal.formRef].validate((valid) => {
        if (!valid) return;
        if (!isTableValid) return;
        /*this.$notify({
            title: '表单数据',
            message: '请在控制台中查看数据输出',
            position: 'bottom-right'
          });
          console.log('表单数据', this.formModel)*/
      });
    },

    resetForm() {
      this.$refs[this.confGlobal.formRef].resetFields();
      this.resetTableData();
    },

    resetTableData() {
      Object.keys(this.tableRefs).forEach((vModel) => {
        // 由于render.js返回的动态组件 所以动态组件相当于是render的子组件
        const res = this.$refs[vModel]["$children"][0].reset();
      });
    },

    checkTableData() {
      let valid = true;
      Object.keys(this.tableRefs).forEach((vModel) => {
        const res = this.$refs[vModel].$children[0].submit(); // 返回false或表单数据
        res ? (this.formModel[vModel] = res) : (valid = false);
      });
      return valid;
    },

    showExplain(explainText, title) {
      if (!explainText) return;
      this.drawerTitle = title;
      this.drawerText = explainText;
      this.drawerVisible = true;
    },

    buildDrawer(h) {
      var content = <pre style="padding-left: 1rem;">{this.drawerText}</pre>;
      return h(
        "el-drawer",
        {
          props: {
            title: this.drawerTitle + "说明",
            visible: this.drawerVisible,
          },
          on: {
            "update:visible": (val) => (this.drawerVisible = val),
          },
        },
        [content]
      );
    },
    /*buildElImgViewer(h){
        return h('el-image-viewer', {
            props: {
              urlList:this.imgPreviewUrl,
              zIndex: 3000,
              initialIndex: this.imgViewerInitialIndex,
              onClose:()=>{
                this.imgViewerVisible = false
              }
            },
            directives:[{
              name:'show',
              value:this.imgViewerVisible
            }]
          })
      },*/
    buildViewer(h) {
      const content = this.imgViewerFileList.map((item) => {
        return (
          <li>
            <img src={item.url} alt={item.name} />
          </li>
        );
      });
      return h("ul", {}, [content]);
    },
    buildForm(h) {
      let labelPosition = this.confGlobal.labelPosition || "left";
      const content = this.confGlobal.fields.map((c) =>
        layouts[c.layout](c, h, this)
      );
      const formObject = {
        props: {
          model: this.formModel,
          rules: this.ruleList,
          disabled: this.confGlobal.disabled,
          size: this.confGlobal.size,
          labelWidth: this.confGlobal.labelWidth + "px",
          labelPosition: this.confGlobal.labelPosition || undefined,
        },
        ref: this.confGlobal.formRef,
      };
      var btns = undefined;
      if (this.formBtns) {
        btns = (
          <el-col span={24}>
            <el-form-item style="text-align:right;">
              <el-button type="primary" onClick={this.submitForm}>
                提交
              </el-button>
              <el-button onClick={this.resetForm}>重置</el-button>
            </el-form-item>
          </el-col>
        );
      }
      // 因为使用jsx时  el-form 的 model 一直无法正确填充，故采用createElement直接渲染
      return h("el-form", formObject, [content, btns]);
    },
    initDefaultData(config) {
      config.fields.forEach((field) => {
        let defv = field.defaultValue;
        // if (field.type == "date") {

        //     defv = this.unixTimestamptoDate(defv,field.format)
        // }
        this.formModel[field.vModel] = defv;
      });
    },
    setData(value, field) {
      this.formModel[field] = value;
    },
    getConfigByAjax() {
      this.confGlobal = Object.freeze(this.conf);
      //   this.initDefaultData(this.conf);
    },
  },
  render(h) {
    if (!this.confGlobal) {
      return <div v-loading="true" class="loading-mask"></div>;
    }
    return (
      <div
        class="preview-container"
        style={"width:" + this.containerWidth + "%;"}
      >
        <el-row gutter={this.confGlobal.gutter} style="padding: 0 2rem 0;">
          {this.buildForm(h)}
        </el-row>
        <div class="width-slider">
          <el-slider vModel={this.containerWidth} min={30} max={96}></el-slider>
        </div>
        <div style="display:none;z-index:9999" id={this.imgViewerId}>
          {this.buildViewer(h)}
        </div>
        {this.buildDrawer(h)}
      </div>
    );
  },
};
</script>
<style lang="stylus" scoped>
.preview-container {
    /* margin 3rem auto 1rem
    border-radius 6px
    box-shadow 0 0 15px rgba(0, 0, 0, .1) */
    .width-slider {
        width: 150px;
        position: absolute;
        top: 0;
        right: 2rem;
        display: none;
    }
}

.showDivider.form-container {
    margin-bottom: 2rem;
}

.loading-mask {
    width: 100vw;
    height: 100vh;
}

/deep/ .el-input.is-disabled .el-input__inner {
    text-align: left;
}
</style>
